<template>
    <div class="d-flex flex-wrap mb-3">
        <v-btn
            class="mr-2 mb-2"
            :color="activeStatus === null ? 'primary' : ''"
            :outlined="activeStatus !== null"
            @click="setStatus(null)">
            All
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="blue"
            :outlined="activeStatus !== 1"
            :dark="activeStatus === 1"
            @click="setStatus(1)">
            Active
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="teal"
            :outlined="activeStatus !== 2"
            :dark="activeStatus === 2"
            @click="setStatus(2)">
            Complete
        </v-btn>
        <v-btn
            class="mr-2 mb-2"
            color="red"
            :outlined="activeStatus !== 3"
            :dark="activeStatus === 3"
            @click="setStatus(3)">
            Cancelled
        </v-btn>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeStatus: null
        };
    },
    methods: {
        setStatus(status) {
            this.activeStatus = status;
            this.$emit('status-change', status);
        }
    }
};
</script>
